module.exports = __webpack_public_path__ + "static/media/img-access-marker.7b3bb2f7.svg";